import React from "react";

import { Divider } from "@material-ui/core";

import { useHistory, useLocation } from "react-router-dom";
import { TreeItem, TreeView } from "@material-ui/lab";

import { Drawer } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { drawerWidth } from "../styles";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { setHeaderTitle } from "../../store/layoutSlide";

const SideBar = ({ open, onClose, open1, onClose1 }) => {
  // const permissions = useSelector((state) => state.user.data?.permissions);
  const navBar = useSelector((state) => state.user?.data?.menu);
  const [t] = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const drawer =
    navBar &&
    JSON.parse(navBar).map((item, index) =>
      item ? (
        <TreeItem
          nodeId={item.code}
          key={index}
          label={<SingleItem label={t(item.code)} icon={item.icon} />}
          expandIcon={<ArrowDropDownIcon style={{ margin: "0 0 0 10px" }} />}
          collapseIcon={<ArrowDropUpIcon style={{ margin: "0 0 0 10px" }} />}
        >
          {item.submenu.map((sub_item, sub_index) => (
            <TreeItem
              key={sub_index}
              label={<SingleItem label={t(sub_item.code)} />}
              onClick={() => {
                if (location.pathname !== sub_item.link) {
                  history.push(sub_item.link);
                }
              }}
              nodeId={sub_item.link}
            />
          ))}
        </TreeItem>
      ) : (
        <Divider key={index} />
      )
    );
  return (
    <div align="left">
      <Drawer
        open={open}
        onClose={onClose}
        sx={{
          display: { lg: "block", xl: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
      >
        {/* <Toolbar/> */}
        <img
          alt=""
          className="canclick"
          style={{ height: 50, margin: "0 10px", objectFit: "contain" }}
          onClick={() => {
            dispatch(setHeaderTitle("Trang chủ"));
            history.push("/");
          }}
          src="/logoP3.png"
        />
        <Divider />
        <div style={{ height: "100%", overflowY: "auto" }}>
          <TreeView selected={location.pathname}>{drawer}</TreeView>
        </div>
      </Drawer>
      <Drawer
        variant="persistent"
        open={open1}
        onClose={onClose1}
        sx={{
          display: { lg: "none", xl: "block", md: "none", xs: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
      >
        {/* <Toolbar/> */}
        <img
          alt=""
          className="canclick"
          style={{ height: 50, margin: "0 10px", objectFit: "contain" }}
          onClick={() => {
            dispatch(setHeaderTitle(""));
            history.push("/");
          }}
          src="/logoP3.png"
        />
        <Divider />
        <div style={{ height: "100%", overflowY: "auto" }}>
          <TreeView selected={location.pathname}>{drawer}</TreeView>
        </div>
      </Drawer>
    </div>
  );
};
export default SideBar;

const SingleItem = ({ label, icon }) => {
  return (
    <div style={{ display: "flex", padding: "10px 0", alignItems: "center" }}>
      {icon}
      <p style={{ margin: "0 10px" }}>{label}</p>
    </div>
  );
};
